import styles from "./stepsBlock.module.scss";
import { Steps } from "../Header/Steps";
import { HidePanelButton } from "../HidePanelButton/HidePanelButton";

export const StepsBlock = () => {
    return (
        <div className={styles.main}>
            <HidePanelButton />
            <Steps />
        </div>
    )
}